module.exports = __webpack_public_path__ + "static/media/verified-check.3e0dbd30.svg";